import React from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import IMG1 from '../assets/img/sentiment_analysis.png';
import IMG2 from '../assets/img/real.png';
import IMG3 from '../assets/img/crack.png';
import IMG10 from '../assets/img/IMG10.png';
import IMG5 from '../assets/img/gevis.png';
import IMG9 from '../assets/img/IMG9.png';
import IMG11 from '../assets/img/doc.png';
import IMG12 from '../assets/img/rec.png';
const data = [
    {
        id: 1,
        name: "DocAI",
        imgURL: IMG11,
        github: "https://github.com/AshiqNoor-S/DocAI",
        demo: "https://github.com/AshiqNoor-S/DocAI",
        description: "This project aims to design a cross-platform solution using React and the Deepgram API for efficient speech-to-text capture and transcription, enabling real-time documentation of doctor-patient consultations. Additionally, it develops a system to facilitate seamless SOAP notes generation from recorded consultations.",
        technologies: ["React", "MongoDB", "Auth0","Deepgram"],
        video: "https://drive.google.com/file/d/1YKL4_i7Mzv87zK8VXOsMvhkrQ1QoByoY/preview"
    },
    {
        id: 2,
        name: "Prompt4All",
        imgURL: IMG9,
        github: "https://github.com/AshiqNoor-S/Prompt4All",
        demo: "https://prompt4-all.vercel.app/",
        description: "A comprehensive platform that allows users to create, share, and discover AI-generated prompts for various creative tasks.",
        technologies: ["Next", "Next-Auth", "Tailwind", "MongoDB"],
        video: "https://drive.google.com/file/d/1MUnvDWsiiAPwhD_QafZqD945jPsD8SFs/preview" // Example video URL
    },
    {
        id: 3,
        name: "Movie Recommendation System",
        imgURL: IMG12,
        github: "https://github.com/AshiqNoor-S/Movie-Recommendation-System",
        demo: "https://github.com/AshiqNoor-S/Movie-Recommendation-System",
        description: "A content-based movie recommender system using cosine similarity, leveraging the TMDB dataset. The system recommends movies and display the posters using the TMDB API. Deployed the recommender system using streamlit.",
        technologies: ["NLTK", "Sklearn", "Pandas","Streamlit"],
        video : "https://drive.google.com/file/d/1NXT9bhpDbjGw4ZIQ349K71llpyApd6Yx/preview"
    },
    {
        id: 4,
        name: "Amazon Review Sentiment Analyser",
        imgURL: IMG1,
        github: "https://github.com/AshiqNoor-S/Amazon-Sentiment-analysis-and-Chatbot",
        demo: "https://qbgimvpmb9qzznejjkgjce.streamlit.app/",
        description: "An application that analyzes Amazon product reviews to determine sentiment and provides a chatbot interface for users to interact with.",
        technologies: ["Python", "NLTK", "Flask", "Streamlit"]
    },
    {
        id: 5,
        name: "Community Connect",
        imgURL: IMG10,
        github: "https://github.com/AshiqNoor-S/Community-Connect",
        demo: "https://community-connect-n7n2.vercel.app/",
        description: "A social platform that connects people within a community, allowing them to share news, events, and resources.",
        technologies: ["React", "MongoDB", "Node"],
        video:"https://drive.google.com/file/d/1eGk5ZO5VeUbyitu4DCGu9RBxILlr0_jb/preview"
    },
    {
        id: 6,
        name: "RealStar",
        imgURL: IMG2,
        github: "https://github.com/AshiqNoor-S/Realstar",
        demo: "https://github.com/AshiqNoor-S/Realstar",
        description: "A real estate platform that helps users find and rate properties based on various criteria.",
        technologies: ["React", "Node.js", "Express", "MySQL"]
    },
    {
        id: 7,
        name: "Gevis",
        imgURL: IMG5,
        github: "https://github.com/AshiqNoor-S/Gesture_Enabled-_System",
        demo: "https://github.com/AshiqNoor-S/Gesture_Enabled-_System",
        description: "A gesture recognition system that enables users to interact with devices using hand gestures.",
        technologies: ["Python", "OpenCV", "TensorFlow"]
    },
    {
        id: 8,
        name: "Game Doo - Landing Page",
        imgURL: IMG3,
        github: "https://github.com/AshiqNoor-S/GameDoo",
        demo: "https://ashiqnoor-s.github.io/GameDoo/",
        description: "A landing page for a gaming platform that provides users with the latest game news, reviews, and updates.",
        technologies: ["HTML", "CSS", "JavaScript"]
    },
    
];

const ProjectDetails = () => {
    const { id } = useParams();
    const project = data.find(p => p.id === parseInt(id));

    if (!project) return <p>Project not found</p>;

    return (
        <div className="project-details">
            <div className="project-header">
                <img src={project.imgURL} alt={project.name} className="project-header-img" />
                <div className="project-header-overlay">
                    <h1>{project.name}</h1>
                </div>
            </div>
            <div className="project-content">
                <p>{project.description}</p>
               
                <h3>Technologies Used</h3>
                <ul className="technologies-list">
                    {project.technologies.map((tech, index) => (
                        <li key={index}>{tech}</li>
                    ))}
                </ul>
                <div className="project-links">
                    <a href={project.github} className='btn' target='_blank' rel="noopener noreferrer">GitHub</a>
                    <a href={project.demo} className='btn btn-primary' target='_blank' rel="noopener noreferrer">Live Demo</a>
                    <Link to="/" className='btn btn-secondary'>Back to Projects</Link>
                </div>
                
                {project.video && (
                    <div className="project-video">
                        <h3>Video Demonstration</h3>
                        <iframe
                            src={project.video}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title={project.name}
                        ></iframe>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ProjectDetails;
